var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"my-title-box"},[_c('div',{staticClass:"title-line"}),_c('div',{staticClass:"title-font"},[_vm._v(_vm._s(_vm.name))]),_vm._m(0),_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-bottom-line"},[_c('img',{attrs:{"src":require("../../../assets/img/title/bottom-line.png"),"alt":""}})])
}]

export { render, staticRenderFns }